/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-04-23T14:56:33.839
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentGoods,
	listRentGoodsInit,
	listRentGoodsByAuthorizations,
	deleteRentGoods
} from '@api/rentmanage/RentGoods';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentGoods({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentGoods(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentGoodsByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentGoodsByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentGoodsInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentGoodsInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentGoods({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentGoods({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
